import { render } from "./SectionStatistics.vue?vue&type=template&id=228692d2"
import script from "./SectionStatistics.vue?vue&type=script&lang=js"
export * from "./SectionStatistics.vue?vue&type=script&lang=js"

import "./SectionStatistics.vue?vue&type=style&index=0&id=228692d2&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__